import { Injectable } from '@angular/core';
import { GrpcEvent, GrpcMessage, GrpcRequest } from '@ngx-grpc/common';
import { GrpcHandler, GrpcInterceptor } from '@ngx-grpc/core';
import { customAlphabet } from 'nanoid';
import { Observable } from 'rxjs';
import { generateTraceIdSegment } from '../utils/trace-id-segment';

@Injectable()
export class TraceIdInterceptor implements GrpcInterceptor {
  public intercept<Q extends GrpcMessage, S extends GrpcMessage>(
    request: GrpcRequest<Q, S>,
    next: GrpcHandler
  ): Observable<GrpcEvent<S>> {
    const traceIdSegment = generateTraceIdSegment();
    const spanIdSegment = customAlphabet('1234567890abcdef', 16)();

    request.requestMetadata.set('X-TEN-Trace-Id', `${traceIdSegment}-TPFE`);
    request.requestMetadata.set('traceparent', `00-${traceIdSegment}-${spanIdSegment}-01`);

    return next.handle(request);
  }
}
